import PropTypes from 'prop-types';

/**
 * Number input component
 * 
 * @param {object} props
 * @param {string} props.id - component ID
 * @param {string} props.label - label text that appears above the input
 * @param {number} props.min - minimum value accepted
 * @param {number} props.max - maximum value accepted
 */
const NumberInput = ({ id, label, labelClassName = "", min, max, value, setValue }) => {
    return (
        <>
            <label className={`input-label ${labelClassName}`} htmlFor={id}>{label}</label>
            <input
                type="number"
                id={id}
                min={min}
                max={max}
                value={value}
                onChange={setValue}
            />
        </>
    );
};

NumberInput.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    labelClassName: PropTypes.string,
    min: PropTypes.number,
    max: PropTypes.number,
};

export default NumberInput;